export default __webpack_public_path__ + "static/media/hexagon.8a10e928.svg";